import Vue from "vue";
import VueComponents from "@tt/vue-components";
import store from "@/store";
import i18n from "@/plugins/i18n";
import router from "@/router";

Vue.use(VueComponents, { store, i18n, router });
